import React, { memo, useEffect, useMemo, useState } from "react";
import { useTable, usePagination, useFilters } from "react-table";
import { useTranslation } from "react-i18next";
import "./style.css";
import { Block } from "../../crRender";
import PageInfo from "./Components/PageInfo";
import Pagging from "./Components/Pagging";

export const PAGE_SIZE = 20;

const Table = ({
  columns,
  data,
  fetchData,
  setTableFiller,
  tableFiller,
  TotalRows,
  isNeedFetch = true,
  hiddenColumns,
  assignRelatedClass,
  isPagination = true,
  isLoading,
  hideActions
}) => {
  const { t } = useTranslation();
  const [paginationPages, setPaginationPages] = useState([])

  const handleHide = useMemo(() => {
    let arr = []
    if (hideActions) {
      arr.push("actions")
    }
    if (hiddenColumns) {
      arr.push(hiddenColumns)
    }
    arr.push("")
    return arr
  }, [hideActions, hiddenColumns])

  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    headerGroups,
    page,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    state: { pageIndex, pageSize, filters },
  } = useTable(
    {
      columns,
      data,
      pageCount: Math.ceil(TotalRows / tableFiller?.pageSize),
      initialState: {
        pageIndex: 0,
        pageSize: tableFiller?.pageSize || 20,
        hiddenColumns: handleHide,
      },
      defaultColumn: { Filter: "" },
      manualPagination: true,
      manualFilters: true,
    },
    useFilters,
    usePagination
  );

  useEffect(() => {
    if (isPagination && isNeedFetch) fetchData({ pageIndex, pageSize, filters });
  }, [fetchData, pageIndex, pageSize, isPagination, filters]);

  useEffect(() => {
    let tempArr = []
    if (TotalRows / tableFiller?.pageSize >= 0) {

      for (var i = 2; i <= Math.ceil(TotalRows / tableFiller?.pageSize); i++) {
        tempArr.push(i)
      }
      setPaginationPages([...tempArr])
    }
  }, [TotalRows, tableFiller?.pageSize])


  return (
    <Block isRender={!isLoading} className="tablet-container">

      <PageInfo TotalRows={TotalRows} pageSize={pageSize} pageIndex={pageIndex} />

      <div className="wrapper-table">
        <table {...getTableProps()} >
          <thead  >
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} >
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()} className={column.id == 'actions' ? "sticky-col" : ''} >
                    {['actions' , 'action'].includes(column.id) ? t("actions") : t(column.render("Header"))}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()} style={{ backgroundColor: "#fff" }}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className={`${assignRelatedClass ? assignRelatedClass(row.cells) : ''}`}>
                  {row.cells.map((cell, index) => {
                    return <td {...cell.getCellProps()} className={cell.column.id === 'actions' ? "sticky" : ""}>
                      {['actions' , 'action'].includes(cell.column.id) ?
                     <div  className="actions-column" >   {cell.render("Cell")} </div> : <div className="table-actions-container">{cell.render("Cell")}</div>
                      }
                    </td>
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Pagging
        previousPage={previousPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        canNextPage={canNextPage}
        setTableFiller={setTableFiller}
        paginationPages={paginationPages}
        pageIndex={pageIndex}
        isPagination={isPagination}
        TotalRows={TotalRows}
        canPreviousPage={canPreviousPage} />

    </Block >
  );
};

export default memo(Table);
